import { render, staticRenderFns } from "./MobileNavbar.vue?vue&type=template&id=8124d784&scoped=true"
import script from "./MobileNavbar.vue?vue&type=script&lang=js"
export * from "./MobileNavbar.vue?vue&type=script&lang=js"
import style0 from "./MobileNavbar.vue?vue&type=style&index=0&id=8124d784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8124d784",
  null
  
)

export default component.exports